<template>
    <div>
        <SubNavigation :navigation="navigation">
            <template #desktop>
                <a
                    v-if="$meta.features.tenants.inventory_feedback"
                    class="navbar-item"
                    @click="showInventoryFeedbackModal"
                >
                    Provide Inventory Feedback
                </a>
            </template>
            <template #mobile>
                <li>
                    <a
                        v-if="$meta.features.tenants.inventory_feedback"
                        class="navbar-item"
                        @click="showInventoryFeedbackModal"
                    >
                        Provide Inventory Feedback
                    </a>
                </li>
            </template>
        </SubNavigation>

        <Notification v-if="! property">
            Loading...
        </Notification>

        <div v-if="property">
            <article class="media mb-3">
                <figure class="media-left">
                    <div class="image-wrapper">
                        <img
                            :src="`/contacts/tenancies/properties/${property.PropertyPK}/photos/first?w=150`"
                            :alt="property.AddressString"
                        />
                    </div>
                </figure>
                <div class="media-content">
                    <div class="content">
                        <p class="title is-4">
                            {{ property.AddressString }}
                        </p>

                        <b-field
                            grouped
                            group-multiline
                        >
                            <div class="control">
                                <b-tooltip
                                    label="Tenancy status"
                                >
                                    <b-taglist attached>
                                        <b-tag type="is-dark">
                                            Status
                                        </b-tag>
                                        <b-tag>
                                            {{ property.PropertyStatus }}
                                        </b-tag>
                                    </b-taglist>
                                </b-tooltip>
                            </div>

                            <div class="control">
                                <b-tooltip
                                    v-if="tenancy.dteOccupiedDate"
                                    label="Tenancy start date"
                                >
                                    <b-taglist attached>
                                        <b-tag type="is-dark">
                                            From
                                        </b-tag>
                                        <b-tag>
                                            {{ tenancy.dteOccupiedDate | formatDate }}
                                        </b-tag>
                                    </b-taglist>
                                </b-tooltip>
                            </div>

                            <div class="control">
                                <b-tooltip
                                    v-if="tenancy.dteVacatingdate"
                                    label="Tenancy end date"
                                >
                                    <b-taglist attached>
                                        <b-tag type="is-dark">
                                            To
                                        </b-tag>
                                        <b-tag>
                                            {{ tenancy.dteVacatingdate | formatDate }}
                                        </b-tag>
                                    </b-taglist>
                                </b-tooltip>
                            </div>
                        </b-field>
                    </div>
                </div>
            </article>

            <hr />

            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Notification from '../components/Notification.vue';
import InventoryFeedbackModal from '../components/InventoryFeedbackModal';
import SubNavigation from '../components/SubNavigation.vue';

export default {
    components: {
        Notification,
        SubNavigation,
    },

    data: function() {
        return {
            navigation: [
                {
                    label: 'Details',
                    name: 'tenancy-property',
                    visible: true,
                },
                {
                    label: 'Key Dates',
                    name: 'tenancy-property-key-dates',
                    visible: this.$meta.features.tenants.key_dates,
                },
                {
                    label: 'Documents',
                    name: 'tenancy-property-documents',
                    visible: this.$meta.features.tenants.documents,
                },
                {
                    label: 'Utilities',
                    name: 'tenancy-property-utilities',
                    visible: this.$meta.features.tenants.utilities,
                },
                {
                    label: 'Pay Online',
                    name: 'tenancy-property-pay',
                    visible: (this.$meta.features.tenants.bank_account || this.$meta.features.tenants.online_payments),
                },
                {
                    label: 'Request Repair',
                    name: 'tenancy-property-request-repair',
                    visible: (this.$meta.features.tenants.fixflo || this.$meta.features.tenants.report_repair_contact_details),
                },
            ],
        };
    },

    computed: {
        ...mapState('tenancyProperty', [
            'property',
            'tenancy',
        ]),
    },

    mounted() {
        this.getTenancy();
    },

    methods: {
        getTenancy() {
            this.$store.dispatch('tenancyProperty/getTenancy', this.$route.params.id)
            .then(() => {
                // redirect with message if tenancy can't be found
                if(this.tenancy === false) {
                    this.$router.push({
                        name: 'tenancies',
                        params: {
                            message: 'Invalid tenancy.',
                        },
                    });
                } else {
                    this.getProperty();
                }
            });
        },
        getProperty() {
            this.$store.dispatch('tenancyProperty/getRow', this.tenancy.PropertyFK)
            .then(() => {
                // redirect with message if property can't be found
                if(this.property === false) {
                    this.$router.push({
                        name: 'tenancies',
                        params: {
                            message: 'Invalid property.',
                        },
                    });
                }
            });
        },
        showInventoryFeedbackModal() {
            this.$buefy.modal.open({
                parent: this,
                component: InventoryFeedbackModal,
                hasModalCard: true,
            });
        },
    },
};
</script>
